import { Flex, Loader } from '@inflearn/ds-react-next';
import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';

import { NEXT_PUBLIC_CDN_URL, NEXT_PUBLIC_SITE_URL } from '../../../../../appConfig';
import AppShellLayoutForCSR from '../../../../components/layout/AppShellLayoutForCSR';
import CustomHead from '../../../../components/layout/CustomHead';

const PAGE_INFORMATION = {
  // CustomHead 가 ` - 인프런` 을 자동으로 덧붙이므로 여기서는 접미사를 넣지 않는다.
  title: '인프럭키드로우',
  description: '매일 1회, START 버튼을 눌러 오늘의 행운을 확인해보세요!',
};

const OG_IMAGE_URL = `${NEXT_PUBLIC_CDN_URL}/public/static-images/73f89e30-63da-4588-bb85-e550132723a8.png`;

const Roulette2026PageLazy = dynamic(
  () =>
    import('../../../../components/pages/summerblackfriday2606/roulette-event').then((module) => ({
      default: module.Roulette2026Page,
    })),
  {
    ssr: false,
    loading: () => (
      <Flex justify="center" align="center" mih="100dvh">
        <Loader />
      </Flex>
    ),
  },
);

export default function Roulette2026Route() {
  return <Roulette2026PageLazy />;
}

Roulette2026Route.getLayout = (page: ReactNode) => {
  return (
    <>
      <CustomHead
        title={PAGE_INFORMATION.title}
        description={PAGE_INFORMATION.description}
        image={OG_IMAGE_URL}
        baseURL={NEXT_PUBLIC_SITE_URL}
      />
      <AppShellLayoutForCSR requiredLogin={false} showChanneltalk={false} showFooter={false}>
        {page}
      </AppShellLayoutForCSR>
    </>
  );
};
